<template>
  <div class="card">
    <div class="card-header bg-primary d-flex justify-content-between">
      <h5 class="mb-0 text-white">Description</h5>
      <DescriptionEditButton v-if="showEditButton" :investigation="investigation" @reload="reload" />
    </div>
    <div class="card-body">
      <p class="m-0">
        <em>{{ investigation.description }}</em>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import formatter from "@/utils/formatter";
import DescriptionEditButton from "@/views/reports/investigations/edit-investigation/DescriptionEditButton.vue";

export default {
  components: {
    DescriptionEditButton,
  },
  props: {
    isLoading: Boolean,
    investigation: Object,
  },
  computed: {
    ...mapGetters("role", ["isVerensicsAdministrator", "isOrganizationAdministrator", "isInvestigationCreator", "isInvestigationViewer"]),
    formatter: () => formatter,
    showEditButton() {
      if (this.investigation.statusCode == "closed") return false;
      return this.isVerensicsAdministrator || this.isOrganizationAdministrator || this.isInvestigationCreator || this.isInvestigationViewer;
    },
  },
  methods: {
    reload() {
      this.$emit("reload");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";
</style>
